module.exports = __webpack_public_path__ + "static/media/ios-happy.1fb7ccc3.svg";